import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

import { HTTPAPI } from './../share.js';

Vue.use(Vuex);

const state = {
  isLoading: true,
  isInitStatus: false,
  currentComercio: null,
  comercios: null
};

export default new Vuex.Store({
  state: state,
  mutations: {
    InitStatus(state){
      state.isInitStatus = true;
      state.isLoading = false;
    },
    setLoading(state, value){
      state.isLoading = value;
    },
    setComercios(state, comercios){
      state.comercios = comercios;
    },
    setCurrentComercio(state, comercio){
      state.currentComercio = comercio;
      state.isLoading = false;
    },
  },
  actions: {
    InitStatus({commit,dispatch}){
      // dispatch('getComercios');
      commit('InitStatus');
    },
    getComercios({commit}){
      HTTPAPI.get(`comercios?id_estado=3`)
      .then(response => {
        let comercios = response.data;
        commit('setComercios', comercios);
      }).catch(e => {
        commit('setComercios', null);
      });
    },
    getCurrentComercio({commit}, id_comercio){
      
      if (id_comercio) {
        HTTPAPI.get(`comercios/${id_comercio}`)
        .then(response => {
          let comercio = response.data;
          commit('setCurrentComercio', comercio);
        })
        .catch(e => {
          commit('setCurrentComercio', null);
        });
      } else {
        commit('setCurrentComercio', null);
      }
    },
  },
  getters : {
    
  },
  modules: {

  }
})